export function AusverkaufAbzeichen({ ausverkauf, ausverkauf_quelle }: {
  ausverkauf?: boolean; ausverkauf_quelle?: 'dr' | 'hand' | null;
}) {
  if (!ausverkauf) return null;
  return <span className="inline-flex shrink-0 rounded bg-warn-soft px-1.5 py-0.5 text-[10px] font-semibold text-warn whitespace-nowrap">
    AUSVERKAUF · {ausverkauf_quelle === 'hand' ? 'Hand' : 'DR'}
  </span>;
}
